export default __webpack_public_path__ + "static/media/FactoryMode.3943b579.svg";